var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showChat)?_c('chat-container',{attrs:{"current-user-id":_vm.currentUserId,"theme":_vm.theme,"is-device":_vm.isDevice},on:{"show-demo-options":function($event){_vm.showDemoOptions = $event}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }